import React, { useContext, useState } from 'react';
import { AppContext } from '../../AppContext';
import { SendStatusEmail } from '../../services/OnbordingService';
import CheckApplicationStatus from '../../component/home/checkStatus/CheckApplicationStatus';
import { useNavigate } from 'react-router-dom';

export default function CheckApplicationStatusContainer() {
    const { setEmail, setCurrentStep, setOrdValue } = useContext(AppContext);
    const [localEmail, setLocalEmail] = useState("");
    const [error, setError] = useState("");

    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const baseURL = window.location.origin;

    const handleInputChange = (e) => {
        setLocalEmail(e.target.value);
    };

    const validateEmail = (email) => {
        const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return regex.test(email);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError("");
        setLoading(true);

        const trimmedEmail = localEmail.trim();

        if (!trimmedEmail) {
            setError("Email is required.");
            setLoading(false);
            return;
        }

        if (!validateEmail(trimmedEmail)) {
            setError("Please enter a valid email address.");
            setLoading(false);
            return;
        }

        setCurrentStep(3);

        try {
            const payload = { email: trimmedEmail, url: baseURL };
            const response = await SendStatusEmail(payload);

            if (response && response.description) {
                setEmail(trimmedEmail);
                setLocalEmail("");
                setOrdValue(response?.ord);

                navigate("/otpCheckStatusContainer", { state: { email: trimmedEmail, ord: response.ord } });
            } else {
                setError("An error occurred. Please try again.");
            }
        } catch (err) {
            if (err.response && err.response.data && err.response.data.description) {
                setError(err.response.data.description);
            } else if (err.response && err.response.data) {

                setError(err.response.data.description);
            } else {
                setError("An unexpected error occurred.");
            }
        } finally {
            setLoading(false);
        }
    };

    return (
        <div>
            <CheckApplicationStatus
                handleSubmit={handleSubmit}
                handleInputChange={handleInputChange}
                error={error}
                email={localEmail}
                loading={loading}
            />
        </div>
    );
}
